
<script>
import axios from 'axios';
import API from '@/services/API.js';
import LayoutPublic from '@/components/layouts/public'
import UiCard from '@/components/ui/Card.vue';
import UiSpinner from '@/components/ui/UiSpinner.vue';

export default {
  name: 'TemporaryWatchmanConfirmation',
  components: {
    LayoutPublic,
    UiCard,
    UiSpinner,
  },
  data() {
    return {
      watch_is_refused: false,
      watch_is_loading: false,
      watch_is_error: false,
      unique_id: undefined,
      cgu_is_error: false,
      cgu_is_accepted: null,
      temporaryWatchData: null
    }
  },
  computed: {
    datis() {
      return this.temporaryWatchData?.datis;
    }
  },
  methods: {
    fetchTemporaryWatchman() {
      this.unique_id = this.$route.params.unique_id;
      this.watch_is_loading = true;
      axios.get(API.route(API.endpoints.public.temporaryWatchman, {unique_id: this.unique_id}))
        .then(response => {
          this.temporaryWatchData = response.data;
          this.watch_is_loading = false;
          if (response.data.validation_cgu) {
            this.cgu_is_accepted = true;
          }
        })
        .catch((error) => {
          this.i18nErrorMessage(`temporary_watchman.back_end_messages.${error?.response?.data?.message}`)
          this.watch_is_loading = false;
          this.watch_is_error = true;
        })
    },
    sendConfirmation( confirmation ) {
      if (confirmation && !this.cgu_is_accepted) {
        window.Vfc.$refs.messages.sendMessage('error', this.$t('temporary_watchman.messages.cgu_not_accepted'));
        this.cgu_is_error = true;
      } else {
        this.watch_is_loading = true;
        axios.post(API.endpoints.public.temporaryWatchmanConfirm, {
          unique_id: this.unique_id,
          validation_cgu: !!this.cgu_is_accepted,
          confirm: confirmation
        })
          .then(response => {
            this.watch_is_loading = false;
            this.cgu_is_error = false;
            if (!confirmation) {
              this.watch_is_refused = true
              window.Vfc.$refs.messages.sendMessage('info', this.$t(`temporary_watchman.back_end_messages.${response.data}`));
            } else {
              this.temporaryWatchData.status = 'accepted';
              window.Vfc.$refs.messages.sendMessage('success', this.$t(`temporary_watchman.back_end_messages.${response.data}`));
            }
          })
          .catch(error => {
            window.Vfc.$refs.messages.sendMessage('error', this.$t(`temporary_watchman.back_end_messages.${error.response.data}`));
            this.i18nErrorMessage(`temporary_watchman.back_end_messages.${error?.response?.data?.message}`)
            this.watch_is_loading = false;
          })
      }
    },
    i18nErrorMessage(i18nErrorPath) {
      window.Vfc.$refs.messages.sendMessage(
        'error',
        this.$te(i18nErrorPath)
          ? this.$t(i18nErrorPath)
          : this.$t('errors.default')
      )
    },
  },
  created() {
    this.fetchTemporaryWatchman();
  },
  beforeCreate() {
    axios.defaults.baseURL = API.apiBaseURL
  },
}
</script>

<template>
  <LayoutPublic>
    <h1 class="text-xl font-semibold mb-3" style="line-height: inherit;">
      <span v-if="watch_is_refused" v-text="$t('temporary_watchman.title_refused')"></span>
      <span v-else v-text="$t('temporary_watchman.title')"></span>
    </h1>
    <div 
      v-if="watch_is_error"
      class="alert alert-danger" 
    >
      {{ $t('temporary_watchman.messages.no_data') }}
    </div>
    <div 
      v-if="watch_is_refused"
      v-html="$t('temporary_watchman.messages.watch_refused', {name: datis.name})"
      class="alert alert-info mb-3"
    ></div>
    <UiSpinner v-if="watch_is_loading" />
    <template v-if="temporaryWatchData && !watch_is_refused">
      <p class="mb-3" style="line-height: inherit;">{{ $t('temporary_watchman.description') }}</p>
      <UiCard 
        v-if="temporaryWatchData && temporaryWatchData.datis"
        class="d-flex align-items-center mx-auto w-fit mb-3"
      >
        <div class="mr-3">
          <i class="fa fa-user-circle text-gray-400 text-5xl"></i>
        </div>
        <div>
          <div 
            v-if="datis.name"
            class="font-semibold"
          >
            {{datis.name}}
          </div>
          <div v-if="datis.client && datis.client.enterprise_name">{{datis.client.enterprise_name}}</div>
          <div v-if="datis.phone">{{datis.phone}}</div>
        </div>
      </UiCard>
      <p class="mb-3">
        <a :href="$t('temporary_watchman.info_link_url')" target="_blank">
          {{ $t('temporary_watchman.info_link_text') }}
        </a>
      </p>
      <hr class="mb-3" />
      <h2 class="font-semibold text-xl mb-3">{{ $t('temporary_watchman.confirm_label') }}</h2>
      <div 
        v-if="temporaryWatchData && temporaryWatchData.status === 'accepted'"
        v-html="$t('temporary_watchman.messages.watch_already_accepted', {name: datis.name})"
        class="alert alert-success mb-3" 
      ></div>
      <div class="mb-3" :class="cgu_is_error && !cgu_is_accepted ? 'text-danger' : ''">
        <b-form-checkbox
          id="checkbox-1"
          v-model="cgu_is_accepted"
          name="checkbox-1"
          :disabled="temporaryWatchData.status === 'accepted'"
        >
          {{ $t('temporary_watchman.cgu_read')}}
          <a :href="$t('temporary_watchman.cgu_link_url')" target="_blank" style="color: inherit; text-decoration: underline;">
            {{ $t('temporary_watchman.cgu_link_text')}}
          </a>.
        </b-form-checkbox>
      </div>
      <div class="d-flex" style="gap: 1rem">
        <b-button variant="warning" class="font-semibold" @click="sendConfirmation(true)">
          {{ $t('temporary_watchman.button_confirm') }}
        </b-button>
        <b-button variant="light" class="font-semibold" @click="sendConfirmation(false)">
          {{ $t('temporary_watchman.button_refuse') }}
        </b-button>
      </div>
    </template>
  </LayoutPublic>
</template>